import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    graph_container: {
        height: "100%",
        width: "100%"
    }
}));

export {useStyles}